export enum DashboardType {
  System = 1,
  Custom = 2,
}
